import React from 'react';
import { Box, Typography } from '@mui/material';
// @ts-ignore - react-markdown will be installed
import ReactMarkdown from 'react-markdown';
import { fontSize, typography } from '@/shared/theme';

interface IProps {
  children: string;
  fontSize?: string;
  fontWeight?: number | string;
  color?: string;
  sx?: React.ComponentProps<typeof Box>['sx'];
}

/**
 * 마크다운 텍스트를 렌더링하는 컴포넌트
 * SessionTimeline 필드 등에서 사용하기 위한 스타일이 적용되어 있습니다.
 */
export function Markdown({
  children,
  fontSize: customFontSize = fontSize.sm,
  fontWeight: customFontWeight = typography.cell.fontWeight,
  color = 'text.primary',
  sx,
}: IProps) {
  return (
    <Box
      sx={{
        width: '100%',
        '& ul': {
          margin: 0,
          paddingLeft: 2,
          listStyleType: 'none',
        },
        '& li': {
          marginBottom: 0.5,
        },
        '& p': {
          margin: 0,
          fontSize: customFontSize,
          fontWeight: customFontWeight,
          color,
          display: 'inline-block',
          padding: '0px 4px',
        },
        '& code': {
          fontFamily: 'monospace',
          backgroundColor: 'action.hover',
          padding: '2px 4px',
          borderRadius: '4px',
          fontSize: customFontSize,
          fontWeight: customFontWeight,
          color,
        },
        '& li > *': {
          fontSize: customFontSize,
          fontWeight: customFontWeight,
          color,
          display: 'inline-block',
          padding: '0px 4px',
        },
        ...sx,
      }}
    >
      <ReactMarkdown
        components={{
          p: ({ children }: { children?: React.ReactNode }) => (
            <Typography
              component="span"
              sx={{
                fontSize: customFontSize,
                fontWeight: customFontWeight,
                color,
                display: 'inline-block',
                padding: '0px 4px',
              }}
            >
              {children}
            </Typography>
          ),
          ul: ({ children }: { children?: React.ReactNode }) => (
            <Box component="ul" sx={{ margin: 0, paddingLeft: 2, listStyleType: 'none' }}>
              {children}
            </Box>
          ),
          li: ({ children }: { children?: React.ReactNode }) => (
            <Box component="li" sx={{ marginBottom: 0.5 }}>
              <Typography
                component="span"
                sx={{
                  fontSize: customFontSize,
                  fontWeight: customFontWeight,
                  color,
                  display: 'inline-block',
                  padding: '0px 4px',
                }}
              >
                {children}
              </Typography>
            </Box>
          ),
          code: ({ children, className }: { children?: React.ReactNode; className?: string }) => {
            return (
              <Typography
                component="span"
                sx={{
                  fontFamily: 'monospace',
                  backgroundColor: 'action.hover',
                  padding: '2px 4px',
                  borderRadius: '4px',
                  fontSize: customFontSize,
                  fontWeight: customFontWeight,
                  color,
                }}
              >
                {children}
              </Typography>
            );
          },
        }}
      >
        {children}
      </ReactMarkdown>
    </Box>
  );
}
